import React from 'react'
import PropTypes from 'prop-types'

import { getMonthlyBillAmount } from '../../utils'
import LineItem from '../../LineItem'

const MonthlyBill = ({
  dataTestId,
  isAuthenticated,
  lang,
  recurring,
  translations,
  isIrpcFlow
}) => {
  const monthlybillCost = getMonthlyBillAmount(recurring, isIrpcFlow)
  const monthlyBillText = translations.monthlyBill
  return (
    <LineItem
      text={monthlyBillText}
      cost={monthlybillCost}
      lang={lang}
      annotationInline
      bold
      amountBold
      dataIdAttribute={`${dataTestId}-price-summary-hs-monthlybill`}
      showTooltip={isAuthenticated}
    />
  )
}

MonthlyBill.propTypes = {
  dataTestId: PropTypes.string.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  lang: PropTypes.string.isRequired,
  recurring: PropTypes.array.isRequired,
  translations: PropTypes.object.isRequired,
  isIrpcFlow: PropTypes.bool.isRequired
}

export default MonthlyBill
